import request from '@/config/axios'

/** 公告类型取值（与后端 NoticeConstants 枚举一致） */
export type NoticeType = 'activity' | 'notice' | 'new'

/** 公告类型下拉选项（搜索区/表单共用；表格 el-tag 颜色映射见页面内 typeTagMap） */
export const NOTICE_TYPE_OPTIONS: { label: string; value: NoticeType }[] = [
  { label: '活动', value: 'activity' },
  { label: '公告', value: 'notice' },
  { label: '上新', value: 'new' }
]

/** 玄学公告 VO */
export interface NoticeVo {
  id?: number
  title: string
  type: NoticeType
  content: string
  sort?: number
  status?: number
  updateTime?: Date
}

/** 分页查询参数 */
export interface NoticePageParams {
  pageNo?: number
  pageSize?: number
  title?: string
  type?: NoticeType
  status?: number
}

export const NoticeApi = {
  // 查询玄学公告分页
  getNoticePage: (params: NoticePageParams) => {
    return request.get({ url: '/xuanxue/notice/page', params })
  },
  // 查询玄学公告详情
  getNotice: (id: number) => {
    return request.get({ url: '/xuanxue/notice/get?id=' + id })
  },
  // 新增玄学公告
  createNotice: (data: NoticeVo) => {
    return request.post({ url: '/xuanxue/notice/create', data })
  },
  // 修改玄学公告
  updateNotice: (data: NoticeVo) => {
    return request.put({ url: '/xuanxue/notice/update', data })
  },
  // 修改玄学公告状态（启用/停用）
  updateNoticeStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/notice/update-status', params: { id, status } })
  },
  // 删除玄学公告
  deleteNotice: (id: number) => {
    return request.delete({ url: '/xuanxue/notice/delete?id=' + id })
  }
}
